import React, { useState } from "react";
import {
  Create,
  SimpleForm,
  required,
  TextInput,
  SelectInput,
  ReferenceInput
} from "react-admin";

import { PostBottomToolbarEdit } from "../CustomElements/PostBottomToolbars";
import {Field} from "react-final-form";
import TinyMCEInput from "../TinyMCEInput";

const requiredField = required();

export default (props) => {
  return (
    <Create {...props} title={"Dodaj typ plika"}>
      <SimpleForm toolbar={<PostBottomToolbarEdit />}>
        <div className="d-flex w-100 justify-content-around">
          <div class="col-md-10">
            <div class="table">
              <table class="table table-striped">
                <tr>
                  <td>
                    <TextInput
                      source="identifier"
                      label="Identyfikator"
                      fullWidth
                      variant="outlined"
                      validate={requiredField}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label
                        style={{
                          fontFamily: "arial",
                          color: "rgba(0, 0, 0, 0.54)",
                          display: "block",
                        }}
                    >Informacja</label>
                    <Field name="info">
                      {(props) => (
                          <TinyMCEInput
                              source="info"
                              height={200}
                          />
                      )}
                    </Field>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </SimpleForm>
    </Create>
  );
};
